import { AutocompleteDTO } from './AutocompleteDTO';
import { Attribute } from './Attribute';
import { InputType } from '../Enums/InputType';
import { ForceDirection } from '../Enums/ForceDirection';
import { CustomValidation } from './CustomValidation';
import { ControlLayout } from '../Enums/ControlLayout';
import { RangeNumber } from './RangeNumber';

export class AutocompleteOptions
{
        /**
   * Represent Name Of Form Control
   */
    Name:string
    /**
  *   Represent classes to textbox that allow us to select the AutoComplete by jquery or javascript 
  */

  ExtraClasses:string
 
  /**  Represent value of the label*/
  LabelValue:string
  
 /**  Represent Key of the label*/
 LabelKey:string
  /**  Represent value of the labelDescription show under textbox*/
  LabelDescription:string
  /** Represent value of the Placeholder of textbox */
  Placeholder:string
  /**To set  value  to textbox */
  Value:AutocompleteDTO=null
  //** Set the MaxLength of characters In AutoComplete */
  MaxLength?:number
  /**Set the MinLength of characters In AutoComplete  */
  MinLength?:number
    //** Set the MaxWordCount of characters In AutoComplete */
    MaxWordCount: number;
  /** set Range Number to Textbox with type number with From-Value and To-value*/
  NumberRange:RangeNumber=new RangeNumber()
  /**Prevent AutoComplete of textbox*/
  AutoComplete:boolean
  /**
   * Display "*" beside the label 
   * if ForceAsterisk=true and IsRequired=True his display "*" ,
   * if if ForceAsterisk=false and IsRequired=false this remove "*",
   *if ForceAsterisk=false and IsRequired=True this display "*" , 
    */ 
  ShowAsterisk: boolean
  /** Ability to set  AutoComplete required */
  IsRequired: boolean
  /** Ability to display or hide the label of AutoComplete */
  HideLabel:  boolean
  /** Sets an attribute disable="disabled"  */
  IsDisabled: boolean
  /**  text input on change  */ 
  TrimTextOnChange: boolean
  /** add button to for coping to clipboard */
  EnableCopyToClipboard: boolean
  /**Prevent  Defulat Password Validation to set Custom Validation */
  RemoveDefulatPasswordValidation:boolean
  /**  to set type of view  if textbox is Vertical or Horizontal */
  ViewType:ControlLayout=ControlLayout.Vertical
  /** Allow to Pass Object With Body of Function which represent CustomValidation and massage for error massage 
  */
 CustomValidation: CustomValidation[]=[]
  /** to set Direction of textbox  if textbox is Arabic or English  */
  ForceDirection: ForceDirection=ForceDirection.English
  /** Set Type of AutoComplete ("text","password","email","number") */
  Type: InputType
  /** Set List of Custom Attribute to AutoComplete  */
  AttributeList:Attribute[]
  /** allow add  value of  AutoComplete dosn't exist in list*/
    AllowNewSelection :boolean =false; 
      ControlId: string;
      /**the url of a remote server that supports jsonp calls */
      ActionURL: string;
      /**a {key,value} (json) object to include as params for the json call. Each api supports different structure.*/
      Params: object={};

  AutocompleteDTO:AutocompleteDTO
  SelectedValue:AutocompleteDTO

}